import { render, staticRenderFns } from "./ServiceMessage.vue?vue&type=template&id=8e61f1ac&"
import script from "./ServiceMessage.vue?vue&type=script&lang=js&"
export * from "./ServiceMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports